import { MAP_TYPES } from "@deck.gl/carto";
import { CONNECTION } from "../config.js";
const VISITORS_SOURCE_ID = "visitorsSource";

const source = {
  id: VISITORS_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: CONNECTION.connection,
  data: `SELECT geo_id, geom, n_visitors, day_of_week, part_of_day FROM ${CONNECTION.project}.${CONNECTION.dataset}.${CONNECTION.table}`,
};

export default source;
